module.exports = __webpack_public_path__ + "static/media/pampy.b8707324.png";